import PropTypes from "prop-types";
import { useContext, useEffect, useRef, useState } from "react";
import { AccordionContext } from "./Accordion";

export function AccordionContent({
  children,
  className,
  gap,
  lazy = true,
  maxHeight,
  style = {},
  id
}) {
  const { open } = useContext(AccordionContext);

  const contentRef = useRef();
  const openedOnceRef = useRef(false);

  const handleTransitionEnd = () => {
    if (open) {
      contentRef.current.style.height = "auto";
      contentRef.current.style.marginTop = gap
    }
  };

  const updateContentHeight = () => {
    contentRef.current.style.marginTop = gap;
    contentRef.current.style.height = contentRef.current.scrollHeight + "px";
  };

  useEffect(() => {
    if (open) {
      openedOnceRef.current = true;

      updateContentHeight();
    } else {
      updateContentHeight();

      // Update on the next paint, so that it animates correctly
      setTimeout(() => {
        if (contentRef.current) {
          contentRef.current.style.height = "0px";
          contentRef.current.style.marginTop = "0px"
        }
      }, 10);
    }
  }, [open]);

  const classNames = ["lds-accordion-content", open ? "open" : "", className];

  return (
    <div
      id={id}
      ref={contentRef}
      className={classNames.join(" ")}
      onTransitionEnd={handleTransitionEnd}
    >
      {/* The component instance is lazy loaded. Makes animation + performance easier. */}
      {(open || openedOnceRef.current || !lazy) && children}
    </div>
  );
}

AccordionContent.propTypes = {
  className: PropTypes.string,
  id: PropTypes.any,
  lazy: PropTypes.bool,
  maxHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  style: PropTypes.object,
};
